import { createProvider } from '@nvision/services/data-provider';

import type { CarrierServiceFilters } from '../../models';
import * as api from './api';
import { normalizeCarrierServiceFilters, normalizeCarrierServices } from './normalize';

export const fetchCarrierServices = createProvider(
  (filters: Partial<CarrierServiceFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCarrierServices(normalizeCarrierServiceFilters(filters), { signal }),
).andThen((res) => normalizeCarrierServices(res));
